// External UI components
import { BounceLoader } from "react-spinners";

// Internal page components
import EmailHeader from "../EmailHeader/EmailHeader";
import EmailBody from "../EmailBody/EmailBody";

// Styles
import membership_styles from "../../UserPortalPage/Body/Memberships/memberships_styles";

// Utilities
import { set_dimensions } from "../../../services/globals";
import { useAppSelector } from "../../../services/StoreHelper";

export const Email = () => {
  const { club } = useAppSelector((state) => state.app);
  const isDesktop = set_dimensions().desktop;
  const isLoading = !club?.clubId;

  return (
    <div className={isDesktop ? "Email" : "Email-Mobile"}>
      {isLoading ? (
        <div style={{ ...membership_styles.loader, height: "80vh" }}>
          <BounceLoader />
        </div>
      ) : (
        <>
          <EmailHeader />
          <EmailBody />
        </>
      )}
    </div>
  );
};